type FreestarPBShortPlacementId =
  | 'ATF_leaderboard'
  | 'incontent_728_reusable'
  | 'incontent_970_reusable'
  | 'siderail_right_atf'
  | 'siderail_left_atf'
  | 'siderail_right_sticky'
  | 'siderail_left_sticky'
  | 'siderail_right_atf_article'
  | 'siderail_left_atf_article'
  | 'siderail_right_sticky_article'
  | 'siderail_left_sticky_article'
  | 'incontent_300x250_reusable';

export type FreestarPBPlacementId =
  | 'pickleball-com_ATF_leaderboard' // Banner for top of pages
  | 'pickleball-com_incontent_728_reusable' // Banner for in-content of pages
  | 'pickleball-com_incontent_970_reusable' // Banner for footer of pages
  | 'pickleball-com_siderail_right_atf'
  | 'pickleball-com_siderail_left_atf'
  | 'pickleball-com_siderail_right_sticky'
  | 'pickleball-com_siderail_left_sticky'
  | 'pickleball-com_siderail_right_atf_article'
  | 'pickleball-com_siderail_left_atf_article'
  | 'pickleball-com_siderail_right_sticky_article'
  | 'pickleball-com_siderail_left_sticky_article'
  | 'pickleball-com_incontent_300x250_reusable';

export const PLACEMENT_IDS_PB: Record<FreestarPBShortPlacementId, FreestarPBPlacementId> = {
  ATF_leaderboard: 'pickleball-com_ATF_leaderboard',
  incontent_728_reusable: 'pickleball-com_incontent_728_reusable',
  incontent_970_reusable: 'pickleball-com_incontent_970_reusable',
  siderail_right_atf: 'pickleball-com_siderail_right_atf',
  siderail_left_atf: 'pickleball-com_siderail_left_atf',
  siderail_right_sticky: 'pickleball-com_siderail_right_sticky',
  siderail_left_sticky: 'pickleball-com_siderail_left_sticky',
  siderail_right_atf_article: 'pickleball-com_siderail_right_atf_article',
  siderail_left_atf_article: 'pickleball-com_siderail_left_atf_article',
  siderail_right_sticky_article: 'pickleball-com_siderail_right_sticky_article',
  siderail_left_sticky_article: 'pickleball-com_siderail_left_sticky_article',
  incontent_300x250_reusable: 'pickleball-com_incontent_300x250_reusable',
};
